import React from "react";
import Empty from "components/Empty";
import { injectIntl } from "react-intl";
import { NumberFormatOptions } from "i18n/helpers";
import StatSiteItem from "components/SiteStat";
import "./component_style.css";

const StatTotalItem = injectIntl(
  ({ click, cost, exposure, intl: { formatNumber } }) => (
    <div className="data-item-container total">
      <div className="data-item-panel">
        <div className="row">
          <div className="col-xs-4">
            <span className="TotalSpan">Итого:</span>
          </div>
          <div className="data-item-body col-xs-8">
            <div className="data-item data-item-exposure">
              <span>Показы</span>
              <span>{(exposure && formatNumber(exposure)) || "-"}</span>
            </div>
            <div className="data-item data-item-cpm" />
            <div className="data-item data-item-cost">
              <span>Доход</span>
              <span>
                {(cost && formatNumber(cost / 1e5, NumberFormatOptions)) || "—"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
);

const StatSites = ({ items, total }) => (
  <div className="statistic-table">
    {items.map((item, idx) => (
      <StatSiteItem
        isEmptyStat={!item.list}
        key={idx}
        {...item.list}
        name={item.name}
        id={item.id}
      />
    ))}
    <StatTotalItem {...total} />
  </div>
);

export default ({ items, total }) =>
  items.length ? <StatSites total={total} items={items} /> : <Empty />;
